// extracted by mini-css-extract-plugin
export default {"ldsRoller":"LoadingSpiner_ldsRoller__-bC54","lds-roller":"LoadingSpiner_lds-roller__4+j-b"};